import { map, toNumber } from 'lodash';

import {
  FullBOUserResponseModel,
  SelfEmployedRequestModel,
} from 'api/backofficeApiClient';

export interface SelfEmployedProfileFormValues {
  ownerInfo: {
    firstName: string;
    lastName: string;
    email: string;
  };
  businessNameSameAsOwner: boolean;
  businessName: string;
  businessPhone: string;
  country?: number;
  state?: number;
  internationalStateName?: string;
  city: string;
  internationalCityName?: string;
  address: string | null;
  zip: string;
  industry: string[];
  assignmentLocations?: number[] | null;
  assignment?: boolean;
  termsAndConditions?: boolean;
  isRegisteredOnMarketPlace?: boolean;
  website?: string;
}

export const mapSelftEployedProfileToRequest = (
  values: SelfEmployedProfileFormValues,
  profileInfo?: FullBOUserResponseModel,
): SelfEmployedRequestModel => {
  const {
    ownerInfo,
    businessNameSameAsOwner,
    businessName,
    businessPhone,
    state,
    city,
    address,
    zip,
    website,
    industry,
    assignmentLocations,
    assignment,
    country,
    internationalStateName,
    internationalCityName,
  } = values;

  return {
    website: website || undefined,
    ownerInfo: {
      firstName: ownerInfo.firstName.trim(),
      lastName: ownerInfo.lastName.trim(),
      email: ownerInfo.email.trim(),
    },
    businessInfo: {
      name: businessNameSameAsOwner
        ? `${ownerInfo.firstName.trim()} ${ownerInfo.lastName.trim()}`
        : businessName.trim(),
      phoneNumber: businessPhone.replace(/\D+/g, ''),
      location: {
        countryId: toNumber(country),
        stateId: state || undefined,
        city: city.trim(),
        address: address?.trim(),
        zipCode: zip?.trim() || undefined,
        internationalStateName: internationalStateName || undefined,
        internationalCityName: internationalCityName?.trim() || undefined,
      },
      industry,

      // for edit we need pass those two fields too, because it is required
      assignmentLocations:
        (!!profileInfo
          ? (map(
              profileInfo?.businessInfo?.assignmentLocations,
              'id',
            ) as number[])
          : assignmentLocations) || undefined,
      assignment: !!profileInfo
        ? profileInfo?.businessInfo?.assignment
        : assignment,
    },
    companyId: profileInfo?.companyId || undefined,
  };
};
